export default "__VITE_ASSET__nCyM8$VE__"